import {
  EDIT_OUTLET_FAILD,
  EDIT_OUTLET_LOADING,
  EDIT_OUTLET_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  status: null,
};

export const editOutletReducer = (
  state = initialState,
  action: { type: any; loading: any; status: any; error: any }
) => {
  switch (action.type) {
    case EDIT_OUTLET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case EDIT_OUTLET_SUCCESS:
      return {
        ...state,
        loading: false,
        status: action.status,
        error: null,
      };
    case EDIT_OUTLET_FAILD:
      return {
        ...state,
        loading: false,
        status: null,
        error: action.error,
      };
    default:
      return state;
  }
};
